(function () {
    'use strict';

    var appHome = angular.module('appHome', [
        // Angular modules 
        // Custom modules 
        'common',                   // common functions, logger, spinner
        'ngCookies',
        'pascalprecht.translate'     //angular translate
        //'tmh.dynamicLocale'       //angular-dynamic-locale

    ]);

    //#region translate
    appHome.config(['$translateProvider', function ($translateProvider) {
        $translateProvider.useStaticFilesLoader({
            prefix: '/app/translations/translation_',
            suffix: '.json?version=43'
        })
       .registerAvailableLanguageKeys(['en', 'it'], {
           'en_*': 'en',
           'it_*': 'it',
           '*': 'en'
       })

       .determinePreferredLanguage()
       //.preferredLanguage('en')
       //.useLocalStorage()
       .fallbackLanguage('en');
        $translateProvider.useLocalStorage();
    }]);
    //#endregion

    //appHome.config(function (tmhDynamicLocaleProvider) {
    //    tmhDynamicLocaleProvider.localeLocationPattern('/node_modules/angular-i18n/angular-locale_{{locale}}.js');
    //});
  
    // Handle routing errors and success events
    appHome.run(['$rootScope', '$translate', '$timeout', function ($rootScope, $translate, $timeout) {
        $rootScope.timeInMs = false;
        var time = function () {
            $rootScope.timeInMs = true;
        }

        $timeout(time, 1000).then(function () {
            var currentLanguage = $translate.proposedLanguage() || $translate.use();
            //inizio cookie
            var cookieName = 'user_accepts_cookies';
            var valore = $.cookie(cookieName) || null;
            if (valore == null) {
                var link = "/informativa-cookie_" + currentLanguage + ".htm";
                $("#uecookielaw").html("<div id='cookielawwrap'><h1>" + ($translate.instant('Cookie')) + "</h1><h3><span class='cookielaw-hidden'>" + $translate.instant('CookieMiglioreEsperienza') + "<br />" + $translate.instant('AccettaCookie') + "</span> <a href='" + link + "' target='_blank'>" + $translate.instant('UlterioriInformazioni') + "</a></h3><div id='uecookielawclose' class='accept'>" + $translate.instant('Accetto') + "</div></div>");
                $("#uecookielaw").addClass("cookielaw");
                $("#uecookielaw").show();
            }
            $("#uecookielawclose").click(function () {
                $.cookie(cookieName, "Normativa letta", { expires: 30, path: '/' });
                $("#uecookielaw").hide();
            });

            //fine cookie
        });
        
       
    }]);

    

})();
